// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/ticket.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Resource } from "./resource";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { FloatValue } from "../../../google/protobuf/wrappers";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.TicketSchema
 */
export interface TicketSchema {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketType types = 3;
     */
    types: TicketType[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketStatus statuses = 4;
     */
    statuses: TicketStatus[];
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 5;
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 6;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomField
 */
export interface TicketCustomField {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 3;
     */
    required: boolean;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldStringValue string_value = 100;
         */
        stringValue: TicketCustomFieldStringValue;
    } | {
        oneofKind: "stringValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldStringValues string_values = 101;
         */
        stringValues: TicketCustomFieldStringValues;
    } | {
        oneofKind: "boolValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldBoolValue bool_value = 102;
         */
        boolValue: TicketCustomFieldBoolValue;
    } | {
        oneofKind: "timestampValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldTimestampValue timestamp_value = 103;
         */
        timestampValue: TicketCustomFieldTimestampValue;
    } | {
        oneofKind: "pickStringValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickStringValue pick_string_value = 104;
         */
        pickStringValue: TicketCustomFieldPickStringValue;
    } | {
        oneofKind: "pickMultipleStringValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickMultipleStringValues pick_multiple_string_values = 105;
         */
        pickMultipleStringValues: TicketCustomFieldPickMultipleStringValues;
    } | {
        oneofKind: "pickObjectValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickObjectValue pick_object_value = 106;
         */
        pickObjectValue: TicketCustomFieldPickObjectValue;
    } | {
        oneofKind: "pickMultipleObjectValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickMultipleObjectValues pick_multiple_object_values = 107;
         */
        pickMultipleObjectValues: TicketCustomFieldPickMultipleObjectValues;
    } | {
        oneofKind: "numberValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldNumberValue number_value = 108;
         */
        numberValue: TicketCustomFieldNumberValue;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldStringValue
 */
export interface TicketCustomFieldStringValue {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
    /**
     * @generated from protobuf field: string default_value = 2;
     */
    defaultValue: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldStringValues
 */
export interface TicketCustomFieldStringValues {
    /**
     * @generated from protobuf field: repeated string values = 1;
     */
    values: string[];
    /**
     * @generated from protobuf field: repeated string default_values = 2;
     */
    defaultValues: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldBoolValue
 */
export interface TicketCustomFieldBoolValue {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldNumberValue
 */
export interface TicketCustomFieldNumberValue {
    /**
     * @generated from protobuf field: google.protobuf.FloatValue value = 1;
     */
    value?: FloatValue;
    /**
     * @generated from protobuf field: google.protobuf.FloatValue default_value = 2;
     */
    defaultValue?: FloatValue;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldTimestampValue
 */
export interface TicketCustomFieldTimestampValue {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp value = 1;
     */
    value?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp default_value = 2;
     */
    defaultValue?: Timestamp;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickStringValue
 */
export interface TicketCustomFieldPickStringValue {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
    /**
     * @generated from protobuf field: repeated string allowed_values = 2;
     */
    allowedValues: string[];
    /**
     * @generated from protobuf field: string default_value = 3;
     */
    defaultValue: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickMultipleStringValues
 */
export interface TicketCustomFieldPickMultipleStringValues {
    /**
     * @generated from protobuf field: repeated string values = 1;
     */
    values: string[];
    /**
     * @generated from protobuf field: repeated string allowed_values = 2;
     */
    allowedValues: string[];
    /**
     * @generated from protobuf field: repeated string default_values = 3;
     */
    defaultValues: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickObjectValue
 */
export interface TicketCustomFieldPickObjectValue {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketCustomFieldObjectValue value = 1;
     */
    value?: TicketCustomFieldObjectValue;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2;
     */
    allowedValues: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: c1.connector.v2.TicketCustomFieldObjectValue default_value = 3;
     */
    defaultValue?: TicketCustomFieldObjectValue;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickMultipleObjectValues
 */
export interface TicketCustomFieldPickMultipleObjectValues {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue values = 1;
     */
    values: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2;
     */
    allowedValues: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue default_values = 3;
     */
    defaultValues: TicketCustomFieldObjectValue[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldObjectValue
 */
export interface TicketCustomFieldObjectValue {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketStatus
 */
export interface TicketStatus {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaRequest
 */
export interface TicketsServiceGetTicketSchemaRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaResponse
 */
export interface TicketsServiceGetTicketSchemaResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema schema = 1;
     */
    schema?: TicketSchema;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceListTicketSchemasRequest
 */
export interface TicketsServiceListTicketSchemasRequest {
    /**
     * @generated from protobuf field: uint32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceListTicketSchemasResponse
 */
export interface TicketsServiceListTicketSchemasResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketSchema list = 1;
     */
    list: TicketSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.Ticket
 */
export interface Ticket {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Resource assignees = 4;
     */
    assignees: Resource[];
    /**
     * @generated from protobuf field: c1.connector.v2.Resource reporter = 5;
     */
    reporter?: Resource;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketStatus status = 7;
     */
    status?: TicketStatus;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketType type = 8;
     */
    type?: TicketType;
    /**
     * @generated from protobuf field: repeated string labels = 9;
     */
    labels: string[];
    /**
     * @generated from protobuf field: string url = 10;
     */
    url: string;
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 11;
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 12;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 13;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 14;
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.connector.v2.Resource requested_for = 15;
     */
    requestedFor?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketType
 */
export interface TicketType {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketRequest
 */
export interface TicketRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketStatus status = 3;
     */
    status?: TicketStatus;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketType type = 4;
     */
    type?: TicketType;
    /**
     * @generated from protobuf field: repeated string labels = 5;
     */
    labels: string[];
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 6;
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: c1.connector.v2.Resource requested_for = 7;
     */
    requestedFor?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceCreateTicketRequest
 */
export interface TicketsServiceCreateTicketRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketRequest request = 1;
     */
    request?: TicketRequest;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema schema = 2;
     */
    schema?: TicketSchema;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 8;
     */
    annotations: Any[];
}
/**
 * TODO(lauren) maybe the error should be a separate proto so we can store retryable error
 *
 * @generated from protobuf message c1.connector.v2.TicketsServiceCreateTicketResponse
 */
export interface TicketsServiceCreateTicketResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Ticket ticket = 1;
     */
    ticket?: Ticket;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string error = 3;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketRequest
 */
export interface TicketsServiceGetTicketRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketResponse
 */
export interface TicketsServiceGetTicketResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Ticket ticket = 1;
     */
    ticket?: Ticket;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string error = 3;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsRequest
 */
export interface TicketsServiceBulkCreateTicketsRequest {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceCreateTicketRequest ticket_requests = 1;
     */
    ticketRequests: TicketsServiceCreateTicketRequest[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsResponse
 */
export interface TicketsServiceBulkCreateTicketsResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceCreateTicketResponse tickets = 1;
     */
    tickets: TicketsServiceCreateTicketResponse[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsRequest
 */
export interface TicketsServiceBulkGetTicketsRequest {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceGetTicketRequest ticket_requests = 1;
     */
    ticketRequests: TicketsServiceGetTicketRequest[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsResponse
 */
export interface TicketsServiceBulkGetTicketsResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceGetTicketResponse tickets = 1;
     */
    tickets: TicketsServiceGetTicketResponse[];
}
// @generated message type with reflection information, may provide speed optimized methods
class TicketSchema$Type extends MessageType<TicketSchema> {
    constructor() {
        super("c1.connector.v2.TicketSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketType },
            { no: 4, name: "statuses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketStatus },
            { no: 5, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 6, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketSchema
 */
export const TicketSchema = new TicketSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomField$Type extends MessageType<TicketCustomField> {
    constructor() {
        super("c1.connector.v2.TicketCustomField", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_value", kind: "message", oneof: "value", T: () => TicketCustomFieldStringValue },
            { no: 101, name: "string_values", kind: "message", oneof: "value", T: () => TicketCustomFieldStringValues },
            { no: 102, name: "bool_value", kind: "message", oneof: "value", T: () => TicketCustomFieldBoolValue },
            { no: 103, name: "timestamp_value", kind: "message", oneof: "value", T: () => TicketCustomFieldTimestampValue },
            { no: 104, name: "pick_string_value", kind: "message", oneof: "value", T: () => TicketCustomFieldPickStringValue },
            { no: 105, name: "pick_multiple_string_values", kind: "message", oneof: "value", T: () => TicketCustomFieldPickMultipleStringValues },
            { no: 106, name: "pick_object_value", kind: "message", oneof: "value", T: () => TicketCustomFieldPickObjectValue },
            { no: 107, name: "pick_multiple_object_values", kind: "message", oneof: "value", T: () => TicketCustomFieldPickMultipleObjectValues },
            { no: 108, name: "number_value", kind: "message", oneof: "value", T: () => TicketCustomFieldNumberValue },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomField
 */
export const TicketCustomField = new TicketCustomField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldStringValue$Type extends MessageType<TicketCustomFieldStringValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldStringValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldStringValue
 */
export const TicketCustomFieldStringValue = new TicketCustomFieldStringValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldStringValues$Type extends MessageType<TicketCustomFieldStringValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldStringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldStringValues
 */
export const TicketCustomFieldStringValues = new TicketCustomFieldStringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldBoolValue$Type extends MessageType<TicketCustomFieldBoolValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldBoolValue", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldBoolValue
 */
export const TicketCustomFieldBoolValue = new TicketCustomFieldBoolValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldNumberValue$Type extends MessageType<TicketCustomFieldNumberValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldNumberValue", [
            { no: 1, name: "value", kind: "message", T: () => FloatValue },
            { no: 2, name: "default_value", kind: "message", T: () => FloatValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldNumberValue
 */
export const TicketCustomFieldNumberValue = new TicketCustomFieldNumberValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldTimestampValue$Type extends MessageType<TicketCustomFieldTimestampValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldTimestampValue", [
            { no: 1, name: "value", kind: "message", T: () => Timestamp },
            { no: 2, name: "default_value", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldTimestampValue
 */
export const TicketCustomFieldTimestampValue = new TicketCustomFieldTimestampValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickStringValue$Type extends MessageType<TicketCustomFieldPickStringValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickStringValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "allowed_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickStringValue
 */
export const TicketCustomFieldPickStringValue = new TicketCustomFieldPickStringValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickMultipleStringValues$Type extends MessageType<TicketCustomFieldPickMultipleStringValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickMultipleStringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "allowed_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickMultipleStringValues
 */
export const TicketCustomFieldPickMultipleStringValues = new TicketCustomFieldPickMultipleStringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickObjectValue$Type extends MessageType<TicketCustomFieldPickObjectValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickObjectValue", [
            { no: 1, name: "value", kind: "message", T: () => TicketCustomFieldObjectValue },
            { no: 2, name: "allowed_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 3, name: "default_value", kind: "message", T: () => TicketCustomFieldObjectValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickObjectValue
 */
export const TicketCustomFieldPickObjectValue = new TicketCustomFieldPickObjectValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickMultipleObjectValues$Type extends MessageType<TicketCustomFieldPickMultipleObjectValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickMultipleObjectValues", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 2, name: "allowed_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 3, name: "default_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickMultipleObjectValues
 */
export const TicketCustomFieldPickMultipleObjectValues = new TicketCustomFieldPickMultipleObjectValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldObjectValue$Type extends MessageType<TicketCustomFieldObjectValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldObjectValue", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldObjectValue
 */
export const TicketCustomFieldObjectValue = new TicketCustomFieldObjectValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketStatus$Type extends MessageType<TicketStatus> {
    constructor() {
        super("c1.connector.v2.TicketStatus", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketStatus
 */
export const TicketStatus = new TicketStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketSchemaRequest$Type extends MessageType<TicketsServiceGetTicketSchemaRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketSchemaRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaRequest
 */
export const TicketsServiceGetTicketSchemaRequest = new TicketsServiceGetTicketSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketSchemaResponse$Type extends MessageType<TicketsServiceGetTicketSchemaResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => TicketSchema },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaResponse
 */
export const TicketsServiceGetTicketSchemaResponse = new TicketsServiceGetTicketSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceListTicketSchemasRequest$Type extends MessageType<TicketsServiceListTicketSchemasRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceListTicketSchemasRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceListTicketSchemasRequest
 */
export const TicketsServiceListTicketSchemasRequest = new TicketsServiceListTicketSchemasRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceListTicketSchemasResponse$Type extends MessageType<TicketsServiceListTicketSchemasResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceListTicketSchemasResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceListTicketSchemasResponse
 */
export const TicketsServiceListTicketSchemasResponse = new TicketsServiceListTicketSchemasResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Ticket$Type extends MessageType<Ticket> {
    constructor() {
        super("c1.connector.v2.Ticket", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "assignees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Resource },
            { no: 5, name: "reporter", kind: "message", T: () => Resource },
            { no: 7, name: "status", kind: "message", T: () => TicketStatus },
            { no: 8, name: "type", kind: "message", T: () => TicketType },
            { no: 9, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 12, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "requested_for", kind: "message", T: () => Resource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.Ticket
 */
export const Ticket = new Ticket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketType$Type extends MessageType<TicketType> {
    constructor() {
        super("c1.connector.v2.TicketType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketType
 */
export const TicketType = new TicketType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketRequest$Type extends MessageType<TicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "message", T: () => TicketStatus },
            { no: 4, name: "type", kind: "message", T: () => TicketType },
            { no: 5, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 7, name: "requested_for", kind: "message", T: () => Resource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketRequest
 */
export const TicketRequest = new TicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceCreateTicketRequest$Type extends MessageType<TicketsServiceCreateTicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceCreateTicketRequest", [
            { no: 1, name: "request", kind: "message", T: () => TicketRequest },
            { no: 2, name: "schema", kind: "message", T: () => TicketSchema },
            { no: 8, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceCreateTicketRequest
 */
export const TicketsServiceCreateTicketRequest = new TicketsServiceCreateTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceCreateTicketResponse$Type extends MessageType<TicketsServiceCreateTicketResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceCreateTicketResponse", [
            { no: 1, name: "ticket", kind: "message", T: () => Ticket },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceCreateTicketResponse
 */
export const TicketsServiceCreateTicketResponse = new TicketsServiceCreateTicketResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketRequest$Type extends MessageType<TicketsServiceGetTicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketRequest
 */
export const TicketsServiceGetTicketRequest = new TicketsServiceGetTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketResponse$Type extends MessageType<TicketsServiceGetTicketResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketResponse", [
            { no: 1, name: "ticket", kind: "message", T: () => Ticket },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketResponse
 */
export const TicketsServiceGetTicketResponse = new TicketsServiceGetTicketResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkCreateTicketsRequest$Type extends MessageType<TicketsServiceBulkCreateTicketsRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkCreateTicketsRequest", [
            { no: 1, name: "ticket_requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceCreateTicketRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsRequest
 */
export const TicketsServiceBulkCreateTicketsRequest = new TicketsServiceBulkCreateTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkCreateTicketsResponse$Type extends MessageType<TicketsServiceBulkCreateTicketsResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkCreateTicketsResponse", [
            { no: 1, name: "tickets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceCreateTicketResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsResponse
 */
export const TicketsServiceBulkCreateTicketsResponse = new TicketsServiceBulkCreateTicketsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkGetTicketsRequest$Type extends MessageType<TicketsServiceBulkGetTicketsRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkGetTicketsRequest", [
            { no: 1, name: "ticket_requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceGetTicketRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsRequest
 */
export const TicketsServiceBulkGetTicketsRequest = new TicketsServiceBulkGetTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkGetTicketsResponse$Type extends MessageType<TicketsServiceBulkGetTicketsResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkGetTicketsResponse", [
            { no: 1, name: "tickets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceGetTicketResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsResponse
 */
export const TicketsServiceBulkGetTicketsResponse = new TicketsServiceBulkGetTicketsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.TicketsService
 */
export const TicketsService = new ServiceType("c1.connector.v2.TicketsService", [
    { name: "CreateTicket", options: {}, I: TicketsServiceCreateTicketRequest, O: TicketsServiceCreateTicketResponse },
    { name: "GetTicket", options: {}, I: TicketsServiceGetTicketRequest, O: TicketsServiceGetTicketResponse },
    { name: "ListTicketSchemas", options: {}, I: TicketsServiceListTicketSchemasRequest, O: TicketsServiceListTicketSchemasResponse },
    { name: "GetTicketSchema", options: {}, I: TicketsServiceGetTicketSchemaRequest, O: TicketsServiceGetTicketSchemaResponse },
    { name: "BulkCreateTickets", options: {}, I: TicketsServiceBulkCreateTicketsRequest, O: TicketsServiceBulkCreateTicketsResponse },
    { name: "BulkGetTickets", options: {}, I: TicketsServiceBulkGetTicketsRequest, O: TicketsServiceBulkGetTicketsResponse }
]);
